import React, { memo, useCallback, useMemo, useState } from "react"
import {
    CardContent,
    Collapse,
    Grid,
    makeStyles,
    Typography
} from "@material-ui/core"
import Card from "shared/Components/Card/Card"
import { Localized, ReactLocalization, useLocalization } from "@fluent/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown"
import { faChevronUp } from "@fortawesome/pro-light-svg-icons/faChevronUp"
import {
    FormInputField,
} from "shared/Modules/Forms/formTypes"
import { DynamicFormField } from "../../Forms/Components/DynamicFormField"
import { IEditMeetingOrderData } from "../../../Types/MeetingPlanning/deliveryForm"
import { IMeetingServiceConfig } from "../../../Types/MeetingPlanning/meetingServiceConfiguration"
import { dynamicFieldToInputField } from "../../Forms/formLib"

const useDeliveryFormStyles = makeStyles((theme) => ({
    mr_2: {
        marginRight: theme.spacing(2),
    },
    mb_2: {
        marginBottom: theme.spacing(2),
    },
    mb_3: {
        marginBottom: theme.spacing(3),
    },
    card: {
        marginTop: '16px !important',
        marginBottom: '16px !important'
    },
    cardContent: {
        padding: '16px !important'
    },
    collapse: {
        width: '100%',
        minHeight: '30px !important',
        visibility: 'visible',
    },
    title: {
        cursor: 'pointer',
        marginBottom: theme.spacing(4),

        '& *': {
            cursor: 'pointer',
        }
    }
}))

export interface IMeetingPlanningPaymentDeliveryFormProps {
    initialMeetingPlanningData: IEditMeetingOrderData | null
    meetingServiceConfigData: IMeetingServiceConfig | null
}

export function useDeliveryPaymentFormFields(initialMeetingPlanningData: IEditMeetingOrderData | null, meetingServiceConfigData: IMeetingServiceConfig | null, requiredMessage: string, l10n: ReactLocalization): FormInputField[] {
    const dynamicPaymentFields = meetingServiceConfigData?.sections?.find((section) => section.title === 'Payment')?.groups?.find((group) => !group.title)

    const fields = dynamicPaymentFields?.fields?.length ? dynamicPaymentFields.fields.map((field) => dynamicFieldToInputField(field, initialMeetingPlanningData, requiredMessage, l10n)).filter((field) => field.key !== 'CREATE_BUYER_PARTY') : []

    return useMemo<FormInputField[]>(() => fields, [l10n, meetingServiceConfigData])
}

const MeetingPlanningPaymentDeliveryForm = ({ initialMeetingPlanningData, meetingServiceConfigData }: IMeetingPlanningPaymentDeliveryFormProps) => {
    const classes = useDeliveryFormStyles()
    const { l10n } = useLocalization()
    const requiredMessage = l10n.getString('error-required', undefined, 'Dette felt skal udfyldes')

    const fields = useDeliveryPaymentFormFields(initialMeetingPlanningData, meetingServiceConfigData, requiredMessage, l10n)

    const [isCollapsed, setIsCollapsed] = useState(true)

    const toggleCollapse = useCallback(() => {
        setIsCollapsed(prev => !prev)
    }, [setIsCollapsed])

    return <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
            <Collapse in={isCollapsed} className={classes.collapse}>
                <Grid item container direction="column" wrap="nowrap" justifyContent="flex-start">
                    <Grid item container alignItems="center" justifyContent="space-between" className={classes.title} onClick={toggleCollapse}>
                        <Localized id="lunch-subscription-basket-step-payment-label">
                            <Typography variant="h6">Betaling</Typography>
                        </Localized>
                        <FontAwesomeIcon icon={isCollapsed ? faChevronUp : faChevronDown}/>
                    </Grid>
                    <Grid item>
                        {fields.map((field, i) => (
                            <Grid key={field.name} item className={classes.mb_3}>
                                <DynamicFormField field={field} />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Collapse>
        </CardContent>
    </Card>
}

export default memo(MeetingPlanningPaymentDeliveryForm)
